module.exports = __webpack_public_path__ + "static/allBirds-footer-5f5fc7b774709637959ea68616d60ea8.png";